import React from "react";
import {Card, Col, Row, Statistic} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useTranslate} from "../../../../hooks/translate.hook";

interface DashboardSummaryProps {
    groupsCount: number;
    checksCount: number;
    healthyChecksCount: number;
    failedChecksCount: number;
}

export const DashboardSummary: React.FC<DashboardSummaryProps> = ({
    groupsCount,
    checksCount,
    healthyChecksCount,
    failedChecksCount,
}) => {
    const t = useTranslate();

    return (
        <Row className="health-center-dashboard__summary" gutter={[16, 16]}>
            <Col xs={24} sm={12} xl={6}>
                <Card className="health-center-dashboard__summary-card health-center-dashboard__summary-card--groups">
                    <Statistic
                        title={t("HEALTH-CENTER.DASHBOARD.GROUPS", {defaultValue: "Groups"})}
                        value={groupsCount}
                        prefix={<FontAwesomeIcon icon={["fas", "cubes"]} />}
                    />
                </Card>
            </Col>
            <Col xs={24} sm={12} xl={6}>
                <Card className="health-center-dashboard__summary-card health-center-dashboard__summary-card--total">
                    <Statistic
                        title={t("HEALTH-CENTER.DASHBOARD.CHECKS", {defaultValue: "All checks"})}
                        value={checksCount}
                        prefix={<FontAwesomeIcon icon={["fas", "clipboard-list"]} />}
                    />
                </Card>
            </Col>
            <Col xs={24} sm={12} xl={6}>
                <Card className="health-center-dashboard__summary-card health-center-dashboard__summary-card--healthy">
                    <Statistic
                        title={t("HEALTH-CENTER.DASHBOARD.HEALTHY", {defaultValue: "Healthy"})}
                        value={healthyChecksCount}
                        valueStyle={{color: "#389e0d"}}
                        prefix={<FontAwesomeIcon icon={["fas", "check-circle"]} />}
                    />
                </Card>
            </Col>
            <Col xs={24} sm={12} xl={6}>
                <Card className="health-center-dashboard__summary-card health-center-dashboard__summary-card--failed">
                    <Statistic
                        title={t("HEALTH-CENTER.DASHBOARD.FAILED", {defaultValue: "Require attention"})}
                        value={failedChecksCount}
                        valueStyle={{color: failedChecksCount > 0 ? "#cf1322" : "#389e0d"}}
                        prefix={
                            <FontAwesomeIcon
                                icon={["fas", failedChecksCount > 0 ? "exclamation-triangle" : "check-circle"]}
                            />
                        }
                    />
                </Card>
            </Col>
        </Row>
    );
};
